<template>
	<div class="message-music-wrap">
		<music-player :tracks="tracks" @open-modal="openMusicModal" />
		<dialog-music-player
			v-if="showMusicModal"
			:tracks="tracks"
			:track-index="selectedTrackIndex"
			@close="closeMusicModal"
		>
		</dialog-music-player>
	</div>
</template>

<script setup lang="ts">
import MusicPlayer from '@/components/MusicPlayer.vue'
import DialogMusicPlayer from './dialogs/DialogMusicPlayer.vue'
import type { MusicTrackObject } from '@/types'
import { ref } from 'vue'

defineProps({
	tracks: {
		type: Array as () => MusicTrackObject[],
		required: true
	},
	createdAt: {
		type: String,
		default: ''
	}
})

const showMusicModal = ref(false)
const selectedTrackIndex = ref(0)

function openMusicModal(trackIndex: number = 0) {
	selectedTrackIndex.value = trackIndex
	showMusicModal.value = true
}

function closeMusicModal() {
	showMusicModal.value = false
}
</script>

<style lang="scss" scoped>
.message-music-wrap {
	width: 100%;
	margin-top: 12px;
	margin-bottom: 24px;
}
</style>
